import { makeRequest } from 'utils/requestLogger';

export default (course_id, feedback_type) =>
    makeRequest('get', `/api/courses/${course_id}/with-feedback?feedback_type=${feedback_type}`);



// WEBPACK FOOTER //
// ./src/app/services/courses/showCoursesWithFeedback.js